module.exports = __webpack_public_path__ + "static/media/live30.9b53face.png";